module.exports = __webpack_public_path__ + "img/logo-light.82a58295.png";